// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DF_29XQRJFFmpU11MiJo {\n  border: 1px solid;\n  border-color: var(--mantine-color-gray-6);\n}\n", "",{"version":3,"sources":["webpack://./jsapp/js/theme/kobo/Paper.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C","sourcesContent":[".root {\n  border: 1px solid;\n  border-color: var(--mantine-color-gray-6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "DF_29XQRJFFmpU11MiJo"
};
export default ___CSS_LOADER_EXPORT___;
